import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ScimIntegrationService } from '@netfoundry-ui/shared/apiv2';
import { IntegrationAuthRequest, IntegrationAuthResponse } from '@netfoundry-ui/shared/model';
import { GrowlerData } from "@netfoundry-ui/shared/growler";
import { GrowlerService } from '@netfoundry-ui/shared/growler';

@Component({
    selector: 'lib-scim-integration-auth',
    templateUrl: './scim-integration-auth.component.html',
    styleUrls: ['./scim-integration-auth.component.scss'],
    standalone: false
})
export class ScimIntegrationAuthComponent {
  @Input() serviceIdentityId: string;
  @Input() jwtConnectionId: string;
  @Input() integrationId: string;
  @Output() authUpdatedEmitter = new EventEmitter<boolean>;

  authToken;
  displayAuthToken = false;
  generatingToken = false;

  constructor(
    private growlerService: GrowlerService,
    private svc: ScimIntegrationService
  ) {
    

  }

  generateAuthToken() {
    this.displayAuthToken = false;
    this.generatingToken = true;
    let authPromise: Promise<any>;
    let actionString: string;

    if(this.serviceIdentityId && this.jwtConnectionId) {
      authPromise = this.svc.rotateAuthToken(this.integrationId);
      actionString = 'rotate';
    } else {
      actionString = 'generate';
      const tenantId = localStorage.getItem('tenantId');
      if(!tenantId) {
        this.growlerService.show(new GrowlerData(
            'error',
            'Error',
            'Failed to generate auth token',
            'Could not find tenantId to use when generating the auth token'
        ))
        return;
      }
      authPromise = this.svc.createAuthToken(this.integrationId, new IntegrationAuthRequest(tenantId));
    }

    authPromise.then((result: IntegrationAuthResponse) => {

        this.growlerService.show(new GrowlerData(
            'success',
            'Success',
            'Successfully ' + actionString + 'd auth token',
            'Successfully ' + actionString + 'd an authentication token for this integration'
        ));
        this.authUpdatedEmitter.emit(true);
        this.authToken = result.encodedJwt;
        this.displayAuthToken = true;
        
    }, (err) => {
      let message: string;
      if(err?.status?.code === 400 && err?.errors && err?.errors.length > 0) {
        message = err.errors[0];
      } else {
        message = "Failed to " + actionString + " authentication token. Contact support if this issue persists";
      }

      this.growlerService.show(new GrowlerData(
            'error',
            'Error',
            'Failed to ' + actionString + ' auth token',
            message
        ));
      this.authUpdatedEmitter.emit(false);
    }).finally(() => {
      this.generatingToken = false;
    });
  }

        

  copyAuthToken() {
    navigator.clipboard.writeText(this.authToken);
    this.growlerService.show(
        new GrowlerData(
            'success',
            'Success',
            'Authentication Token Copied',
            'The Authentication token for this Integration has been copied to your clipboard'
        )
    );
  }
}
